// extracted by mini-css-extract-plugin
export default {"productDescription":"_ca-z","featuredDescription":"ada-z","description":"bda-z","more":"cda-z","descriptionSku":"dda-z"};